export function toError(response) {
  response.data = response.data || {};
  const data = response.data;
  let code;
  if (Array.isArray(data)) {
    code = data[0].code || data[0];
  } else {
    code = data.code;
  }
  response.data.message = code;
  return Promise.reject(response);
}